import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  display: "flex",
  bgcolor: "background.default",
  borderRadius: 1.5,
  p: 0.625,
  mb: 3.5,
};

export const tab =
  (active: boolean): SxProps<Theme> =>
  (theme) => ({
    flex: 1,
    border: "none",
    borderRadius: 1.125,
    py: 1.25,
    px: 1,
    fontFamily: theme.typography.fontFamily,
    fontSize: "0.90625rem",
    fontWeight: 700,
    cursor: "pointer",
    transition: "all 0.2s ease",
    bgcolor: active ? "background.paper" : "transparent",
    color: active ? "primary.main" : "text.secondary",
    boxShadow: active ? theme.shadows[2] : "none",
  });
